import { combineReducers } from 'redux';
import complaintArbitration from './complaintArbitration';

export const customerComplaint = combineReducers({
    complaintArbitration,
});
